var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import log from 'loglevel';

var DataTableHeader = function (_Component) {
    _inherits(DataTableHeader, _Component);

    function DataTableHeader() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, DataTableHeader);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DataTableHeader.__proto__ || Object.getPrototypeOf(DataTableHeader)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.getChildContext = function () {
            return {
                d2: _this.state.d2
            };
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(DataTableHeader, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            if (!this.props.d2) {
                log.error('D2 is a required prop to <AppWithD2 />');
            } else {
                this.props.d2.then(function (d2) {
                    return _this2.setState({ d2: d2 });
                }).catch(function (error) {
                    return log.error(error);
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var getChildren = function getChildren() {
                if (!_this3.props.children) {
                    return null;
                }
                return React.Children.map(_this3.props.children, function (child) {
                    return React.cloneElement(child);
                });
            };

            return React.createElement(
                'div',
                null,
                getChildren()
            );
        }
    }]);

    return DataTableHeader;
}(Component);

DataTableHeader.propTypes = {
    children: PropTypes.element,
    d2: PropTypes.shape({
        then: PropTypes.func.isRequired
    })
};

DataTableHeader.childContextTypes = {
    d2: PropTypes.object
};

export default DataTableHeader;


//////////////////
// WEBPACK FOOTER
// ./~/d2-ui/lib/app/AppWithD2.component.js
// module id = 537
// module chunks = 13